import { render } from "./ScopesInput.vue?vue&type=template&id=7e271df1&scoped=true"
import script from "./ScopesInput.vue?vue&type=script&lang=js"
export * from "./ScopesInput.vue?vue&type=script&lang=js"

import "./ScopesInput.vue?vue&type=style&index=0&id=7e271df1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e271df1"]])

export default __exports__